import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { SectionHeading } from "@/components/site/primitives";

/**
 * Progressive-disclosure FAQ block. Keeps pages content-rich for SEO
 * while staying visually clean — answers stay collapsed until tapped.
 */
export default function FaqAccordion({
  eyebrow = "FAQ",
  title = "Common",
  highlight = "Questions",
  faqs = [],
  bg = "#F0EFEA",
}) {
  const [open, setOpen] = useState(0);
  return (
    <section className="relative py-24" style={{ backgroundColor: bg }} data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-5 sm:px-8">
        <SectionHeading center eyebrow={eyebrow} title={title} highlight={highlight} className="mb-12" />
        <div className="space-y-3">
          {faqs.map((f, i) => (
            <div key={i} className="bg-white border border-[#E7E5DF] rounded-2xl overflow-hidden" data-testid={`faq-item-${i}`}>
              <button
                onClick={() => setOpen(open === i ? -1 : i)}
                aria-expanded={open === i}
                data-testid={`faq-toggle-${i}`}
                className="w-full flex items-center justify-between gap-4 p-5 text-left font-display font-bold text-[#0B0F14]"
              >
                {f.q}
                <ChevronDown size={20} className={`shrink-0 text-emerald-700 transition-transform ${open === i ? "rotate-180" : ""}`} />
              </button>
              {open === i && <p className="px-5 pb-5 -mt-1 text-slate-600 text-sm leading-relaxed" data-testid={`faq-answer-${i}`}>{f.a}</p>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
